import { useQuery } from "@tanstack/react-query";
import api from "../config/axiosConfig";

//Hook para cacheLoader
export const fetchTipoContingencia = async () => {
  const response = await api.get("/tipoContingencia");
  return response.data;
};

// Hook reutilizable con React Query
export const useTipoContingencia = () => {
  return useQuery({
    queryKey: ["tipoContingencia"],
    queryFn: fetchTipoContingencia,
    staleTime: 1000 * 60 * 60 * 24 * 7, // 7 días (igual que en CacheLoader.js)
    cacheTime: 1000 * 60 * 60 * 24 * 14, // 14 días (igual que en CacheLoader.js)
  });
};
